<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row v-if="inventory">
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Product Details</template>
          <div>
            <b-row>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title">Product Code</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      inventory.details.itemcode
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title">Product Name</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{ inventory.details.name }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="12">
                <b-row>
                  <b-col cols="5" md="2">
                    <span class="item_title">Description</span>
                  </b-col>
                  <b-col cols="7" md="10">
                    <span class="item_value">{{
                      inventory.details.description
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>

              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title">MRP</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      inventory.inv.selling_price 
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title">Selling Price</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      inventory.inv.price 
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <!-- <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title">Available Quantity</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      inventory.inv.available_quantity
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col> -->
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title">Enabled</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      String(inventory.inv.enabled)
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12">
                <span class="item_title">Images</span>
              </b-col>
              <b-col cols="12" v-if="inventory.inv.images.length > 0">
                <b-row>
                  <b-col
                    cols="3"
                    v-for="(item, i) in inventory.inv.images"
                    :key="i"
                  >
                    <b-img :src="baseURL + '/r/' + item" fluid></b-img>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
          </div>

          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                :to="'/Inventory/Edit/' + $route.params.productId"
                >Edit</b-button
              >
            </div>
            <div class="px-2">
              <b-button
                variant="danger"
                size="sm"
                @click.prevent="confirmRemoveProduct"
                >Remove Product</b-button
              >
            </div>
          </b-row>

          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      appLoading: false,
      msg: null,
      ServerError: false,
      inventory: {
        details: {},
        inv: {
          images: [],
        },
      },
    };
  },
  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.appLoading = true;
      axios({
        // url: "/inv/item/id",
        url: "/inv/item",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          shop: localStorage.getItem("shopid"),
          item: this.$route.params.productId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.inventory = response.data.data;
          if (this.inventory.inv.images == null) this.inventory.inv.images = [];
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmRemoveProduct() {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to Remove this Product.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.removeProduct();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    removeProduct() {
      this.appLoading = false;
      axios({
        method: "DELETE",
        url: "/inventory/" + this.inventory.inv.id,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Product Deleted Successfully",
              text: "",
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            var vm = this;

            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.ServerError = true;
        });
    },
  },
};
</script>
<style scoped>
#map {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>